import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ShortkeyContext from './ShortkeyContext';

const Section = styled.div`
  &:not(:first-child) {
    margin-top: 1rem;
  }
`;

const SectionTitle = styled.div`
  font-size: 1.2rem;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Key = styled.span`
  font-size: 0.8rem;
  font-family: monospace;
  background: #ddd;
  border: 1px solid #ccc;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 2px;
`;

const Description = styled.span``;

const ShortkeyViewer: React.FC = () => {
  const { shortkeys } = useContext(ShortkeyContext);

  const [t] = useTranslation();

  return (
    <div>
      {shortkeys.map(section =>
        section.get('shortkeys').length > 0 ? (
          <Section key={section.get('section')}>
            <SectionTitle>
              {t('shortkey-section-' + section.get('section'))}
            </SectionTitle>
            {section.get('shortkeys').map(({ key, description }) => (
              <Row key={key}>
                <span>
                  {key.split('+').map((k, i) => (
                    <React.Fragment key={k}>
                      {i > 0 && ' + '}
                      <Key>{k}</Key>
                    </React.Fragment>
                  ))}
                </span>
                <Description>{description}</Description>
              </Row>
            ))}
          </Section>
        ) : null
      )}
    </div>
  );
};

export default ShortkeyViewer;
